module.exports = __webpack_public_path__ + "static/media/internal-transfer-card.0499cf6c.png";